import React from 'react';
export function Footer() {
  return <footer className="bg-cabbage-dark text-cream/60 py-8 md:py-12 border-t border-white/10" data-id="element-80">
      <div className="container mx-auto px-5 md:px-6 max-w-6xl flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6" data-id="element-81">
        <div className="text-center md:text-left" data-id="element-82">
          <h3 className="font-serif text-2xl text-white italic mb-2" data-id="element-83">
            Repollo
          </h3>
          <p className="text-sm" data-id="element-84">
            Ensaladas de verano, recetas, encurtidos y batidos.
          </p>
        </div>

        <div className="text-sm text-center md:text-right" data-id="element-85">
          <p data-id="element-86">
            &copy; {new Date().getFullYear()} Guía de Recetas. Todos los
            derechos reservados.
          </p>
          <div className="mt-2 space-x-4" data-id="element-87">
            <a href="#" className="hover:text-white transition-colors" data-id="element-88">
              Términos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-89">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-90">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}